import React, { useEffect, useState } from 'react';
import { Grid, Paper, Typography, Box, Card, CardContent } from '@mui/material';
import { TrendingUp, CardGiftcard, People, AttachMoney } from '@mui/icons-material';
import { analyticsAPI } from '../../services/api';

export default function Dashboard() {
  const [stats, setStats] = useState({
    totalRewards: 0,
    activeRewards: 0,
    totalRedemptions: 0,
    revenue: 0
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await analyticsAPI.getMyStats();
      setStats(response.data.data);
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  const StatCard = ({ title, value, icon, color }) => (
    <Card>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Box>
            <Typography color="textSecondary" gutterBottom>{title}</Typography>
            <Typography variant="h4">{value}</Typography>
          </Box>
          <Box sx={{ color, fontSize: 48 }}>{icon}</Box>
        </Box>
      </CardContent>
    </Card>
  );

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Partner Dashboard</Typography>
      
      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Rewards"
            value={stats.totalRewards}
            icon={<CardGiftcard />}
            color="#4A90E2"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Active Rewards"
            value={stats.activeRewards}
            icon={<TrendingUp />}
            color="#50C878"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Redemptions"
            value={stats.totalRedemptions}
            icon={<People />}
            color="#FFB800"
          />
        </Grid>
        
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Revenue"
            value={`£${stats.revenue.toFixed(2)}`}
            icon={<AttachMoney />}
            color="#EF4444"
          />
        </Grid>
      </Grid>

      <Paper sx={{ p: 3, mt: 3 }}>
        <Typography variant="h6" gutterBottom>Welcome to FTNS+ Partner Portal</Typography>
        <Typography variant="body1" color="text.secondary">
          Manage your rewards, track performance, and grow your business with FTNS+.
        </Typography>
      </Paper>
    </Box>
  );
}
